/**
 * Guard de salida del wizard de configuración de recaudador.
 * Solo consulta al componente; no valida ítems del sidebar.
 */
import { CanDeactivateFn } from '@angular/router';
import type { ConfiguracionRecaudadorComponent } from './configuracion-recaudador.component';

/**
 * Intercepta la salida de la ruta cuando el wizard está incompleto.
 */
export const configuracionRecaudadorCanDeactivate: CanDeactivateFn<
  ConfiguracionRecaudadorComponent
> = (component) => component.canDeactivate();
